/**
 * @generated SignedSource<<9761fe0ef908fcdca558c30904fa8d41>>
 * @relayHash 5dbc8ffa5c7200eed2cef57624e60c23
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5dbc8ffa5c7200eed2cef57624e60c23

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteConsultationReportInput = {
  id: string;
};
export type useDeleteConsultationReportMutation$variables = {
  input: Ch_deleteConsultationReportInput;
};
export type useDeleteConsultationReportMutation$data = {
  readonly ch_deleteConsultationReport: {
    readonly ch_ConsultationReport: {
      readonly id: string;
    } | null;
  };
};
export type useDeleteConsultationReportMutation = {
  response: useDeleteConsultationReportMutation$data;
  variables: useDeleteConsultationReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_deleteConsultationReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ConsultationReport",
            "kind": "LinkedField",
            "name": "ch_ConsultationReport",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeleteConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_deleteConsultationReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ConsultationReport",
            "kind": "LinkedField",
            "name": "ch_ConsultationReport",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5dbc8ffa5c7200eed2cef57624e60c23",
    "metadata": {},
    "name": "useDeleteConsultationReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e522d79e8262dddf32063c5c3cf4e93f";

export default node;
